module.exports = __webpack_public_path__ + "img/halls-of-the-dead-run.b552d4cf.png";